import cx from 'classnames';
import NextLink from 'next/link';

import {Button, TallyLogo} from '#component/base';
import {sprinkles} from '#style/sprinkles';
import {theme} from '#theme';

import {FullscreenModalHeaderProps} from './FullscreenModalHeader.types';

import * as css from './FullscreenModalHeader.css';

export const FullscreenModalHeader = ({
  className,
  buttonVariant = 'secondary',
  logoColor = 'burgundy',
  hideCloseButton = false,
  closeButtonHref = '/dashboard',
  closeButtonLabel = 'Return to Dashboard',
  ...otherProps
}: FullscreenModalHeaderProps) => (
  <div
    className={cx(
      sprinkles({
        content: 'between',
        flex: 'flex',
        items: 'center',
        w: 'full',
        zIndex: 1,
      }),
      {height: theme.heights.fullscreenModalHeader},
      className,
    )}
    {...otherProps}>
    <TallyLogo className={css.logo} color={logoColor} size={73} />

    {!hideCloseButton && (
      <NextLink passHref href={closeButtonHref}>
        <Button aria-label={closeButtonLabel} as="a" icon="X" variant={buttonVariant} />
      </NextLink>
    )}
  </div>
);
